import { CloseIcon, DownloadIcon } from "@chakra-ui/icons";
import { Box, Button, Image, Link } from "@chakra-ui/react";
import { CustomModal } from "components/custom-modal";
import { useModalControls } from "hooks/use-modal-controls";
import { useRef, useState } from "react";
import { makeEvent } from "services/events";

const eventName = "open-modal-whatsapp-image";

interface ModalWhatsAppImageProps {
  src: string;
  type: "image" | "video" | "sticker";
  mimetype?: string;
}

export function ModalWhatsAppImage() {
  const { isOpen, onClose } = useModalControls(eventName, {
    onOpen: ({ src, type, mimetype }) => {
      setSrc(src);
      setMediaType(type);
      setMimetype(mimetype);
    },
    onClose: () => {
      setSrc(undefined);
      setMediaType("image");
      setMimetype("");
    }
  });
  const linkRef = useRef<HTMLAnchorElement>(null);
  const [src, setSrc] = useState();
  const [mediaType, setMediaType] = useState("image");
  const [mimetype, setMimetype] = useState("");

  const modalFooter = (
    <>
      <Button
        leftIcon={<DownloadIcon />}
        onClick={() => {
          linkRef.current!.click();
        }}
      >
        {mediaType === "image" || mediaType === "sticker"
          ? "Baixar Imagem"
          : "Baixar Vídeo"}
      </Button>
      <Button
        leftIcon={<CloseIcon w="11px" h="11px" />}
        onClick={onClose}
        variant="outline"
      >
        Fechar
      </Button>
    </>
  );

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      size={"xl"}
      modalTitle={
        mediaType === "image"
          ? "Imagem WhatsApp"
          : mediaType === "sticker"
            ? "Figurinha WhatsApp"
            : "Video WhatsApp"
      }
      modalFooter={modalFooter}
    >
      {mediaType === "image" || mediaType === "sticker" ? (
        <Image w="100%" src={src} />
      ) : (
        <Box width="100%" borderRadius="10px" overflow="hidden">
          <video width="100%" controls>
            <source src={src} type={mimetype} />
            Your browser does not support the video tag.
          </video>
        </Box>
      )}
      <Link ref={linkRef} download display="none" href={src} />
    </CustomModal>
  );
}

export function openModalWhatsAppImage(params: ModalWhatsAppImageProps) {
  makeEvent(eventName, params);
}
